import React from "react";
import Icon from "./Icon";

const UserSvg = () => <Icon name="user" className="h-6 w-6" strokeWidth="1.5" />;

export default UserSvg;
